import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import {
  CreateIntegrationPayload,
  Integration,
  IntegrationStatus,
  IntegrationType,
} from './integrations.types'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['Integrations'],
  endpoints: (builder) => ({
    getIntegrationStatuses: builder.query<
      IntegrationStatus[],
      { userId: string; integrationType?: IntegrationType }
    >({
      query: ({ userId, integrationType }) => ({
        url: 'oapi/v1/integrations/status',
        params: {
          userId,
          ...(integrationType ? { integrationType } : {}),
        },
      }),
      providesTags: (_result, _error, { userId }) => [
        { type: 'Integrations', id: userId },
      ],
    }),

    createIntegration: builder.mutation<Integration, CreateIntegrationPayload>({
      query: (body) => ({
        url: 'oapi/v1/integrations',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        { type: 'Integrations', id: userId },
      ],
    }),

    getIntegrationById: builder.query<Integration, { integrationId: string }>({
      query: ({ integrationId }) => ({
        url: `oapi/v1/integrations/${integrationId}`,
      }),
      providesTags: (_result, _error, { integrationId }) => [
        { type: 'Integrations', id: integrationId },
      ],
    }),

    getIntegrations: builder.query<Integration[], { userId: string }>({
      query: ({ userId }) => ({
        url: 'oapi/v1/integrations',
        params: { userId },
      }),
      providesTags: (_result, _error, { userId }) => [
        { type: 'Integrations', id: userId },
      ],
    }),
  }),
})

export const {
  useGetIntegrationStatusesQuery,
  useCreateIntegrationMutation,
  useGetIntegrationByIdQuery,
  useLazyGetIntegrationsQuery,
} = integrationsApi
